// Show cart popup on page load if items exist (collection view only)
document.addEventListener('DOMContentLoaded', function() {

  var isCollectionPage = window.location.pathname.includes('/collections/') && !window.location.pathname.includes('/products/');

  if (isCollectionPage) {
    fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        localStorage.setItem('cartCount', cart.item_count);

        if (cart.item_count > 0) {
          var cartImg = (cart.items && cart.items.length > 0 && cart.items[0].image) ? cart.items[0].image : localStorage.getItem('lastCartImage');
          if (cartImg && cartImg.startsWith('//')) {
            cartImg = 'https:' + cartImg;
          }
          showPersistentCartPopup(cart.item_count, cartImg);
        }
      })
      .catch(function(e) { console.error(e); });
  }

  // EVENT DELEGATION (Use capture phase true to intercept click BEFORE theme scripts)
  document.body.addEventListener('click', function(e) {
    var btn = e.target.closest('.product-block__add-to-cart-btn');
    if (!btn) return;

    e.preventDefault();
    e.stopPropagation(); // Stop theme listeners from double-processing

    var form = btn.closest('form');
    var productCard = btn.closest('.product-block');
    var isCollectionPage = window.location.pathname.includes('/collections/') && !window.location.pathname.includes('/products/');

    var qtyInput = form ? form.querySelector('input[name="quantity"]') : null;
    var addedQty = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;

    var productImage = null;
    var imgElement = productCard ? productCard.querySelector('img') : null;

    if (imgElement) {
      var srcset = imgElement.getAttribute('data-srcset') || imgElement.getAttribute('srcset');
      if (srcset) {
        var urlMatch = srcset.match(/^[^\s]+/);
        productImage = urlMatch ? urlMatch[0] : null;
      }
      if (!productImage) {
        productImage = imgElement.getAttribute('data-src') || imgElement.src;
      }
      if (productImage && productImage.startsWith('//')) {
        productImage = 'https:' + productImage;
      }
    }

    if (productImage) {
      localStorage.setItem('lastCartImage', productImage);
    }

    if (form) {
      var formData = new FormData(form);

      // 1. INSTANT CALCULATED COUNT
      var currentCount = parseInt(localStorage.getItem('cartCount') || '0', 10);
      var optimisticCount = currentCount + addedQty;
      localStorage.setItem('cartCount', optimisticCount);

      // 2. IMMEDIATE LOCK & RENDER
      forceLockAndSyncUI(optimisticCount, productImage, isCollectionPage);

      // 3. BACKGROUND NETWORK SYNC
      fetch('/cart/add.js', { method: 'POST', body: formData })
        .then(function(r) { return r.json(); })
        .then(function() {
          return fetch('/cart.js');
        })
        .then(function(r) { return r.json(); })
        .then(function(cart) {
          var realCount = cart.item_count;
          localStorage.setItem('cartCount', realCount);
          forceLockAndSyncUI(realCount, productImage, isCollectionPage);
        })
        .catch(function(e) { console.error(e); });
    }
  }, true); // Use Capture phase
});

function forceLockAndSyncUI(count, productImage, isCollectionPage) {
  // Update Popup immediately
  if (isCollectionPage) {
    var existingPopup = document.getElementById('cart-popup-current');
    if (existingPopup) {
      var imgEl = existingPopup.querySelector('.cart-popup-image');
      if (imgEl && productImage) {
        imgEl.src = productImage;
      }
      var popupCount = existingPopup.querySelector('.cart-popup-count');
      if (popupCount) {
        popupCount.textContent = count + ' item' + (parseInt(count, 10) > 1 ? 's' : '');
      }
      existingPopup.classList.add('show');
    } else {
      createAndShowPopup(count, productImage);
    }
  }

  // Update Header Count immediately
  updateHeaderCartCount(count);
}

function createAndShowPopup(itemCount, productImage) {
  var existingPopup = document.getElementById('cart-popup-current');
  if (existingPopup) {
    existingPopup.remove();
  }

  var popup = document.createElement('div');
  popup.className = 'cart-popup show';
  popup.id = 'cart-popup-current';

  var imageHtml = '';
  if (productImage) {
    imageHtml = '<img class="cart-popup-image" src="' + productImage + '" alt="Product">';
  }

  var itemText = itemCount + ' item' + (parseInt(itemCount, 10) > 1 ? 's' : '');
  popup.innerHTML = '<div class="cart-popup-content">' + imageHtml + '<div class="cart-popup-body"><div class="cart-popup-info"><p class="cart-popup-message">View cart</p><p class="cart-popup-count">' + itemText + '</p></div></div><button class="cart-popup-view-btn">›</button></div>';

  document.body.appendChild(popup);

  popup.querySelector('.cart-popup-view-btn').addEventListener('click', function() {
    window.location.href = '/cart';
  });
}

function showPersistentCartPopup(itemCount, imageUrl) {
  createAndShowPopup(itemCount, imageUrl);
}

function updateHeaderCartCount(count) {
  var cartLink = document.querySelector('a[href*="/cart"]');

  if (cartLink) {
    var countBadge = cartLink.querySelector('.cart-count, .cart-link__count, .header__cart-count, .site-header__cart-count, [data-cart-count]');

    if (countBadge) {
      countBadge.textContent = count;
    } else {
      var allSpans = cartLink.querySelectorAll('span');
      var targetSpan = null;

      allSpans.forEach(function(span) {
        if (!span.querySelector('svg') && /^\d+$/.test(span.textContent.trim())) {
          targetSpan = span;
        }
      });

      if (targetSpan) {
        targetSpan.textContent = count;
      } else {
        var badgeSpan = document.createElement('span');
        badgeSpan.className = 'cart-count-badge';
        badgeSpan.textContent = count;
        cartLink.appendChild(badgeSpan);
      }
    }
  }
}